import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import{ convertStringToElements }from "@vds/html-parsers";

import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";
import { checkIfMDNisSMSCapable, fetchProfileAPI } from "../DownloadAndDelete/actions";

import Header from "common-components/Header";
import Container from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";
import Alert from "common-components/Alert";
import { AssignAgentForm } from "./AssignAgentForm";

class AssignAuthorizedAgent extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props, "pageContent", "sc_pagetitle")) {
      this.props.setA11yContent("assign authorized agent", this.props.pageContent.sc_pagetitle);
    }
  }

  onSubmit = e => {
    e.preventDefault();

    const { isEmailVerified, isMTNVerified } = window.reactGlobals;
    const route =
      checkAMLob() === "vzt" && (isEmailVerified === "N" && isMTNVerified === "N")
        ? "/privacy/secure/email-not-verified"
        : "/privacy/secure/multifactor-authentication-primer";

    const next = () =>
      this.props.history.push(route, {
        confirmAuth: true,
        hideChangeDeviceButton: true,
        nextRoute: "/privacy/secure/your-data/authorized-agent/review"
      });
    if (checkAMLob() === "vzw") {
      this.props.fetchProfileAPI().then(() => {
        if (!this.props.error) {
          const { loggedInMdn } = window.reactGlobals;
          const { deviceList } = this.props;
          const mfaMdn = deviceList.find(device => device.mtn === loggedInMdn);

          this.props
            .checkIfMDNisSMSCapable(mfaMdn && mfaMdn.encryptedMtn ? mfaMdn.encryptedMtn : "")
            .then(() => {
              const { mfaAllowed } = this.props.verifiedSecurePinDevice;

              if (!this.props.error) {
                if (mfaAllowed === false) {
                  this.props.history.push("/privacy/secure/action-needed");
                } else {
                  next();
                }
              }
            });
        }
      });
    } else {
      next();
    }
  };

  render() {
    if (!this.props.pageContent) {
      return <Redirect to="/privacy/secure/your-data/authorized-agent/information" />;
    }

    if (this.props.loading) {
      return <RectangleLoader id="formerLoader" />;
    }

    const { section_title, section_description } = this.props.pageContent;

    return (
      <Container>
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}

        <Header>{section_title}</Header>
        <p style={{ margin: "40px 0", maxWidth: "595px" }}>{convertStringToElements(section_description)}</p>
        <AssignAgentForm onSubmit={this.onSubmit} />
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: { assign_agent_form: pageContent },
  loadingAndErrorState: { loading, error },
  profileInformation: deviceList,
  verifiedSecurePinDevice
}) => ({
  pageContent,
  loading,
  error,
  deviceList,
  verifiedSecurePinDevice
});

export default connect(
  mapStateToProps,
  { setA11yContent, checkIfMDNisSMSCapable, fetchProfileAPI }
)(AssignAuthorizedAgent);
